<template>
  <div class="modal fade show" style="display: block" tabindex="-1" aria-hidden="false">
    <div class="modal-dialog modal-dialog-centered modal-width-premium-compact">
      <div class="modal-content">
        <div class="modal-header justify-content-end">
          <button type="button" class="close-link" @click="$emit('close')">
            <i class="ti ti-close"></i>
          </button>
        </div>
        <div class="modal-body padd-modal-premium">
          <div class="title-modal">
            <img :src="reminderIcon" />
            <h3>{{ $t("reminder.create_modal_title") }}</h3>
          </div>
          <form class="mt-4 modal-form-premium" @submit.prevent="handleSubmit">
            <div class="form-container-premium">
              <div class="form-row-premium mb-2">
                <div class="input-form input-form-half">
                  <label class="label-control">Propriétaire*</label>
                  <div class="position-relative">
                    <select
                      v-model="form.ownerId"
                      class="form-select normal-select"
                      :class="{ 'is-invalid': errors.ownerId }"
                      required
                    >
                      <option value="" disabled>Sélectionner un propriétaire</option>
                      <option v-for="owner in formattedOwners" :key="owner.id" :value="owner.id">
                        {{ owner.fullName }}
                      </option>
                    </select>
                    <i
                      class="ti ti-user position-absolute"
                      style="right: 35px; top: 50%; transform: translateY(-50%); color: #ff6b35"
                    ></i>
                  </div>
                  <div v-if="errors.ownerId" class="invalid-feedback">
                    {{ errors.ownerId }}
                  </div>
                </div>
                <div class="input-form input-form-half">
                  <label class="label-control">Date de mise en place*</label>
                  <input
                    type="date"
                    class="form-control"
                    v-model="form.dateMiseEnPlace"
                    :class="{ 'is-invalid': errors.dateMiseEnPlace }"
                    required
                  />
                  <div v-if="errors.dateMiseEnPlace" class="invalid-feedback">
                    {{ errors.dateMiseEnPlace }}
                  </div>
                </div>
              </div>
              <div class="mb-2">
                <div class="input-form input-form-full">
                  <label class="label-control">Référence produit*</label>

                  <div v-if="!hasProducts" class="alert alert-info">Aucun produit disponible</div>

                  <div v-else class="product-selector">
                    <div class="position-relative">
                      <div
                        class="form-control d-flex justify-content-between align-items-center"
                        @click="toggleProductDropdown"
                        style="cursor: pointer; min-height: 60px"
                        :class="{ 'is-invalid': errors.productVariantId }"
                      >
                        <div class="d-flex gap-3 align-items-center">
                          <img
                            :src="getProductImage(selectedProduct)"
                            alt="img"
                            v-if="getProductImage(selectedProduct)"
                            style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px"
                          />
                          <div v-if="selectedProduct">
                            <div class="fw-bold">{{ selectedProduct.name }}</div>
                            <div class="text-muted small">{{ selectedProduct.gamme }}</div>
                          </div>
                          <span v-else class="text-muted">Sélectionner un produit</span>
                        </div>
                        <i
                          class="ti ti-angle-down"
                          :class="{ 'rotate-180': showProductDropdown }"
                          style="transition: transform 0.2s"
                        ></i>
                      </div>

                      <div
                        v-show="showProductDropdown"
                        class="position-absolute w-100 bg-white border rounded shadow-lg"
                        style="top: 100%; z-index: 1050; max-height: 300px; overflow-y: auto"
                      >
                        <div
                          v-for="product in availableProducts"
                          :key="product.id"
                          class="p-3 border-bottom hover-bg-light d-flex gap-3 align-items-center"
                          style="cursor: pointer"
                          @click="selectProduct(product)"
                        >
                          <img
                            :src="getProductImage(product)"
                            alt="img"
                            style="width: 40px; height: 40px; object-fit: cover; border-radius: 4px"
                            v-if="getProductImage(product)"
                          />
                          <div>
                            <div class="fw-bold">{{ product.name }}</div>
                            <div class="text-muted small">{{ product.gamme }}</div>
                          </div>
                        </div>
                        <div v-if="availableProducts.length === 0" class="p-3 text-center text-muted">
                          Aucun produit disponible
                        </div>
                      </div>
                    </div>
                    <div v-if="errors.productVariantId" class="invalid-feedback">
                      {{ errors.productVariantId }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="selectedProduct" class="mb-2">
                <div class="input-form input-form-full">
                  <label class="label-control">Conditionnement*</label>
                  <select
                    v-model="form.productVariantId"
                    class="form-select"
                    :class="{ 'is-invalid': errors.productVariantId }"
                    required
                  >
                    <option value="" disabled>Sélectionner un conditionnement</option>
                    <option
                      v-for="variant in availableVariants"
                      :key="variant.id"
                      :value="variant.id"
                      :disabled="!variant.inStock && !(variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date())"
                    >
                      {{ formatVariantDisplay(variant) }}
                      {{ (!variant.inStock && !(variant.datePrecommandeSupplyvetEsupplyvet && new Date(variant.datePrecommandeSupplyvetEsupplyvet) > new Date())) ? " (Rupture de stock)" : "" }}
                    </option>
                  </select>
                  <div v-if="errors.productVariantId" class="invalid-feedback">
                    {{ errors.productVariantId }}
                  </div>
                </div>
              </div>
              <div class="form-row-premium mb-2">
                <div class="input-form input-form-half">
                  <label class="label-control">Ration journalière*</label>
                  <div class="position-relative">
                    <div class="input-group">
                      <input
                        type="number"
                        class="form-control"
                        v-model.number="form.rationJournaliere"
                        :class="{ 'is-invalid': errors.rationJournaliere }"
                        min="1"
                        max="9999"
                        step="1"
                        placeholder="Entrer la quantité"
                        required
                      />
                      <span class="input-group-text">g</span>
                    </div>
                    <i
                      class="ti ti-weight position-absolute"
                      style="right: 45px; top: 50%; transform: translateY(-50%); color: #ff6b35"
                    ></i>
                  </div>
                  <div v-if="errors.rationJournaliere" class="invalid-feedback">
                    {{ errors.rationJournaliere }}
                  </div>
                </div>
                <div class="input-form input-form-half">
                  <label class="label-control">Mode de rappel*</label>
                  <div class="d-flex align-items-center gap-4 mt-2">
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="notificationEmail"
                        value="email"
                        v-model="form.notificationType"
                        :class="{ 'is-invalid': errors.notificationType }"
                      />
                      <label class="form-check-label" for="notificationEmail"> Email </label>
                    </div>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="notificationSMS"
                        value="sms"
                        v-model="form.notificationType"
                        :class="{ 'is-invalid': errors.notificationType }"
                      />
                      <label class="form-check-label" for="notificationSMS"> SMS </label>
                    </div>
                  </div>
                  <div v-if="errors.notificationType" class="invalid-feedback d-block">
                    {{ errors.notificationType }}
                  </div>
                </div>
              </div>
              <div v-if="calculatedData.bagDuration" class="alert alert-info">
                <h6>{{ $t("reminder.automatic_calculations") }}</h6>
                <ul class="mb-0">
                  <li>
                    {{ $t("reminder.bag_duration") }}: <strong>{{ calculatedData.bagDuration }}</strong>
                  </li>
                  <li>
                    {{ $t("reminder.end_date") }}: <strong>{{ calculatedData.endDate }}</strong>
                  </li>
                </ul>
              </div>
              <div v-if="errors.general" class="alert alert-danger">
                {{ errors.general }}
              </div>
              <div class="d-flex justify-content-center gap-3 mt-4">
                <button type="button" class="btn btn-outline-orange btn-premium" @click="$emit('close')">
                  Annuler
                </button>
                <button type="submit" class="btn btn-orange btn-premium" :disabled="loading">
                  <span v-if="loading"> <i class="ti ti-loader"></i> Création... </span>
                  <span v-else>Valider</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show"></div>
</template>

<script>
  import reminderIcon from "@/assets/images/rappel.svg";
  import { useProprietairesStore } from "@/stores/esupplyvet/proprietairesStore";
  import { useProductsStore } from "@/stores/productsStore";
  import { useAnimauxStore } from "@/stores/animauxStore";

  export default {
    name: "ReminderCreateModal",
    emits: ["close", "submit"],
    data() {
      return {
        reminderIcon,
        form: {
          ownerId: null,
          productVariantId: null,
          rationJournaliere: "",
          dateMiseEnPlace: "",
          notificationType: [],
        },
        errors: {},
        loading: false,
        selectedProduct: null,
        selectedProductId: null,
        showProductDropdown: false,
        availableProducts: [],
        availableVariants: [],
      };
    },
    computed: {
      proprietairesStore() {
        return useProprietairesStore();
      },
      productsStore() {
        return useProductsStore();
      },
      animauxStore() {
        return useAnimauxStore();
      },
      formattedOwners() {
        return this.proprietairesStore.formattedProprietaires || [];
      },
      hasProducts() {
        return this.availableProducts.length > 0;
      },
      calculatedData() {
        if (!this.form.rationJournaliere || !this.selectedVariant || !this.form.dateMiseEnPlace) {
          return {};
        }

        const dailyRation = parseFloat(this.form.rationJournaliere);
        const variantWeight = parseFloat(this.selectedVariant.weight) * 1000; // Convertir kg en g

        if (dailyRation > 0 && variantWeight > 0) {
          const duration = Math.round(variantWeight / dailyRation);
          const startDate = new Date(this.form.dateMiseEnPlace);
          const endDate = new Date(startDate);
          endDate.setDate(startDate.getDate() + duration);

          return {
            bagDuration: `${duration} jours`,
            endDate: endDate.toLocaleDateString("fr-FR"),
          };
        }

        return {};
      },
      selectedVariant() {
        if (!this.form.productVariantId) return null;
        return this.availableVariants.find(v => v.id === this.form.productVariantId);
      },
    },
    mounted() {
      this.form.dateMiseEnPlace = new Date().toISOString().split("T")[0];
      this.availableProducts = this.productsStore.reminderProducts || [];

      if (this.availableProducts.length === 0) {
        console.warn("Aucun produit disponible - vérifier le préchargement dans RappelView");
      }
    },
    methods: {
      onProductSelect() {
        if (!this.selectedProductId) {
          this.selectedProduct = null;
          this.availableVariants = [];
          this.form.productVariantId = null;
          return;
        }

        this.selectedProduct = this.availableProducts.find(p => p.id === this.selectedProductId);

        if (this.selectedProduct) {
          this.availableVariants = (this.selectedProduct.variantsDetails || []).filter(variant => variant.unity === "u");

          this.form.productVariantId = null;

          if (this.availableVariants.length > 0) {
            const firstAvailable = this.availableVariants.find(v => 
              (v.inStock || (v.datePrecommandeSupplyvetEsupplyvet && new Date(v.datePrecommandeSupplyvetEsupplyvet) > new Date())) && 
              v.enabled !== false
            );
            if (firstAvailable) {
              this.form.productVariantId = firstAvailable.id;
            }
          }
        }
      },

      selectProduct(product) {
        this.selectedProduct = product;
        this.form.productVariantId = null;
        this.showProductDropdown = false;

        this.availableVariants = (product.variantsDetails || []).filter(variant => variant.unity === "u");

        if (this.availableVariants.length > 0) {
          const firstAvailable = this.availableVariants.find(v => 
            (v.inStock || (v.datePrecommandeSupplyvetEsupplyvet && new Date(v.datePrecommandeSupplyvetEsupplyvet) > new Date())) && 
            v.enabled !== false
          );
          if (firstAvailable) {
            this.form.productVariantId = firstAvailable.id;
          }
        }
      },

      toggleProductDropdown() {
        this.showProductDropdown = !this.showProductDropdown;
      },

      getProductImage(product) {
        if (!product) return null;
        if (product.imagesDetails && product.imagesDetails.length > 0) {
          return product.imagesDetails[0].path;
        }
        if (product.images && product.images.length > 0) {
          return product.images[0].path;
        }
        return null;
      },

      formatPrice(price) {
        if (!price) return "Prix non disponible";
        return `${(price / 100).toFixed(2)} €`;
      },

      formatVariantDisplay(variant) {
        if (!variant) return "";

        let display = variant.name || "Variant";

        if (variant.weight) {
          display += ` - ${variant.weight}kg`;
        }

        if (variant.currentChannelPricings?.price) {
          display += ` - ${this.productsStore.formatPrice(variant.currentChannelPricings.price)}`;
        }

        return display;
      },

      validateForm() {
        this.errors = {};
        let isValid = true;

        if (!this.form.ownerId) {
          this.errors.ownerId = "Le propriétaire est obligatoire";
          isValid = false;
        }

        if (!this.form.productVariantId) {
          this.errors.productVariantId = "Le produit est obligatoire";
          isValid = false;
        }

        if (!this.form.rationJournaliere || this.form.rationJournaliere <= 0) {
          this.errors.rationJournaliere = "La ration journalière doit être supérieure à 0";
          isValid = false;
        }

        if (!this.form.dateMiseEnPlace) {
          this.errors.dateMiseEnPlace = "La date de mise en place est obligatoire";
          isValid = false;
        }

        if (!this.form.notificationType || this.form.notificationType.length === 0) {
          this.errors.notificationType = "Au moins un type de notification est requis";
          isValid = false;
        }

        return isValid;
      },

      async handleSubmit() {
        if (!this.validateForm()) {
          return;
        }

        try {
          this.loading = true;
          this.errors = {};

          const reminderData = {
            ownerId: parseInt(this.form.ownerId),
            productVariantId: parseInt(this.form.productVariantId),
            rationJournaliere: this.form.rationJournaliere.toString(),
            dateMiseEnPlace: this.form.dateMiseEnPlace,
            notificationType: this.form.notificationType,
          };

          this.$emit("submit", reminderData);
        } catch (error) {
          console.error("Erreur lors de la soumission:", error);
          this.errors.general = "Une erreur est survenue lors de la création du rappel";
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .modal-width-premium {
    max-width: 75% !important;
  }

  .modal-width-premium-compact {
    max-width: 65% !important;
    margin: 0 auto !important;
    padding: 0 25px !important;
  }

  .padd-modal-premium {
    padding: 25px 35px 35px !important;
  }

  .modal-form-premium {
    max-width: 100%;
  }

  .form-container-premium {
    width: 100%;
    max-width: none;
  }

  .form-row-premium {
    display: flex;
    gap: 20px;
    align-items: flex-start;
    width: 100%;
  }

  .input-form-full {
    width: 100% !important;
    margin-bottom: 12px !important;
  }

  .input-form-half {
    width: 100% !important;
    flex: 1;
    margin-bottom: 12px !important;
  }

  .input-form-full .form-control,
  .input-form-half .form-control,
  .input-form-full .form-select,
  .input-form-half .form-select {
    min-height: 48px;
    padding: 12px 20px;
    font-size: 15px;
    border-radius: 35px;
    border: 1px solid #aeb1ba;
    transition: all 0.3s ease;
  }

  .input-form-full .form-control:focus,
  .input-form-half .form-control:focus,
  .input-form-full .form-select:focus,
  .input-form-half .form-select:focus {
    border-color: #1e347d;
    box-shadow: 0 0 0 0.2rem rgba(30, 52, 125, 0.15);
    outline: none;
  }

  .input-form-full .label-control,
  .input-form-half .label-control {
    font-size: 15px;
    font-weight: 500;
    color: #363739;
    margin-bottom: 8px;
    display: block;
  }

  .btn-premium {
    min-width: 140px !important;
    padding: 12px 30px !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    border-radius: 35px !important;
    transition: all 0.3s ease !important;
  }

  .btn-premium:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  .product-selector .form-control {
    cursor: pointer;
    min-height: 60px;
    border-radius: 35px;
    padding: 15px 20px;
    transition: all 0.3s ease;
  }

  .product-selector .form-control:hover {
    border-color: #1e347d;
    box-shadow: 0 0 0 0.1rem rgba(30, 52, 125, 0.1);
  }

  .product-selector .position-absolute {
    border-radius: 15px;
    border: 1px solid #dee2e6;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    overflow: hidden;
  }

  .product-selector .hover-bg-light:hover {
    background-color: #f8f9fa;
    transition: background-color 0.2s ease;
  }

  .input-group {
    border-radius: 35px;
    overflow: hidden;
    border: 1px solid #aeb1ba;
    transition: all 0.3s ease;
  }

  .input-group:focus-within {
    border-color: #1e347d;
    box-shadow: 0 0 0 0.2rem rgba(30, 52, 125, 0.15);
  }

  .input-group .form-control {
    border: none;
    border-radius: 0;
    box-shadow: none;
  }

  .input-group .form-control:focus {
    border: none;
    box-shadow: none;
  }

  .input-group-text {
    background-color: #f8f9fa;
    border: none;
    color: #6c757d;
    font-weight: 500;
    padding: 12px 15px;
  }

  .form-check {
    margin-bottom: 0;
  }

  .form-check-input {
    width: 18px;
    height: 18px;
    margin-top: 0.125em;
    border-radius: 4px;
    border: 2px solid #aeb1ba;
    transition: all 0.3s ease;
  }

  .form-check-input:checked {
    background-color: #ec621a !important;
    border-color: #ec621a !important;
  }

  .form-check-input:focus {
    border-color: #ec621a;
    box-shadow: 0 0 0 0.2rem rgba(236, 98, 26, 0.15);
  }

  .form-check-label {
    font-size: 15px;
    font-weight: 500;
    color: #363739;
    margin-left: 8px;
  }

  .alert {
    border-radius: 15px;
    border: none;
    padding: 15px 20px;
    margin-bottom: 20px;
  }

  .alert-info {
    background-color: #e3f2fd;
    color: #1565c0;
    border-left: 4px solid #2196f3;
  }

  .alert-danger {
    background-color: #ffebee;
    color: #c62828;
    border-left: 4px solid #f44336;
  }

  @media (max-width: 768px) {
    .modal-width-premium {
      max-width: 95% !important;
    }

    .modal-width-premium-compact {
      max-width: 95% !important;
      padding: 0 15px !important;
    }

    .padd-modal-premium {
      padding: 20px 20px 25px !important;
    }

    .form-row-premium {
      flex-direction: column;
      gap: 0;
    }

    .input-form-half {
      width: 100% !important;
    }

    .btn-premium {
      min-width: 120px !important;
      padding: 10px 25px !important;
    }
  }
  .hover-bg-light:hover {
    background-color: #f8f9fa;
  }

  .rotate-180 {
    transform: rotate(180deg);
  }
  .product-selector {
    position: relative;
  }

  .product-selector .dropdown-menu {
    position: absolute;
    top: 100%;
    left: 0;
    right: 0;
    z-index: 1050;
    max-height: 300px;
    overflow-y: auto;
    background: white;
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;
    box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
  }

  .product-selector .dropdown-item {
    padding: 0.75rem 1rem;
    border-bottom: 1px solid #dee2e6;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }

  .product-selector .dropdown-item:hover {
    background-color: #f8f9fa;
  }

  .product-selector .dropdown-item:last-child {
    border-bottom: none;
  }

  .product-selector img {
    width: 40px;
    height: 40px;
    object-fit: cover;
    border-radius: 4px;
    flex-shrink: 0;
  }
  .ti-angle-down {
    transition: transform 0.2s ease;
  }

  .ti-angle-down.rotate-180 {
    transform: rotate(180deg);
  }
</style>
